import { z } from 'zod';
import { APP_ENVIRONMENTS } from '@tsgecart/config';

/**
 * Validated shape of Vite's import.meta.env for the web app. Only
 * VITE_-prefixed variables are ever exposed to the browser bundle — never
 * put a secret in here.
 */
export const webEnvSchema = z.object({
  VITE_APP_ENV: z.enum(APP_ENVIRONMENTS),
  VITE_API_BASE_URL: z.string().url().optional(),
  /**
   * Reserved for a possible future non-Clerk form (e.g. a public contact/
   * waitlist form) that needs its own Turnstile widget + server-side
   * siteverify check. NOT used by /sign-in or /sign-up: those render
   * Clerk's prebuilt components, and bot protection for them is Clerk's
   * own Dashboard-configured "Bot sign-up protection" feature (Cloudflare
   * Turnstile under the hood, applied automatically to Clerk's hosted UI)
   * — see docs/security-model.md "Turnstile / bot protection".
   */
  VITE_TURNSTILE_SITE_KEY: z.string().optional(),
  /** Clerk publishable key — explicitly designed to be public (same pattern as a Stripe publishable key). Read by apps/web/src/App.tsx. */
  VITE_CLERK_PUBLISHABLE_KEY: z.string().optional(),
});

export type WebEnv = z.infer<typeof webEnvSchema>;

export function parseWebEnv(raw: unknown): WebEnv {
  return webEnvSchema.parse(raw);
}
